import React from 'react';
import { Button } from './ui/button';
import { Music, Menu, X } from 'lucide-react';
import { useState } from 'react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showAssessmentWarning, setShowAssessmentWarning] = useState(false);

  const handleJoinClick = (e) => {
    e.preventDefault();
    setShowAssessmentWarning(true);
  };

  const proceedToAssessment = () => {
    setShowAssessmentWarning(false);
    window.location.href = '#/assessment';
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#home" className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition-opacity">
            <img 
              src="https://customer-assets.emergentagent.com/job_nadja-divine-choir/artifacts/d8wqvckb_Anointing%20-%201.png" 
              alt="Divine Anointing Logo"
              className="w-12 h-12 object-contain"
            />
            <div>
              <h1 className="font-bold text-xl text-gray-900">Nadja Scott</h1>
              <p className="text-sm text-gray-600">Divine Anointing</p>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-gray-700 hover:text-red-600 transition-colors">Home</a>
            <a href="#about" className="text-gray-700 hover:text-red-600 transition-colors">About</a>
            <a href="#services" className="text-gray-700 hover:text-red-600 transition-colors">Services</a>
            <a href="#gallery" className="text-gray-700 hover:text-red-600 transition-colors">Gallery</a>
            <a href="#album" className="text-gray-700 hover:text-red-600 transition-colors">Album</a>
            <a href="#books" className="text-gray-700 hover:text-red-600 transition-colors">Nadja Scott the Author</a>
            <a href="#/assessment" onClick={handleJoinClick} className="text-red-600 font-bold hover:text-red-700 transition-colors">Join the Choir</a>
            <a href="#bus-of-blessings" className="text-gray-700 hover:text-red-600 transition-colors">Donate</a>
            <a 
              href="https://docs.google.com/forms/d/12hphFMKBt-Zd44mV26mRSBOZkxx0veNAx_E3yN2YRw8/viewform"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-red-600 transition-colors"
            >
              Contact
            </a>
            <a href="#/admin" className="text-gray-700 hover:text-red-600 transition-colors">Admin</a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a 
              href="https://docs.google.com/forms/d/12hphFMKBt-Zd44mV26mRSBOZkxx0veNAx_E3yN2YRw8/viewform"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-full">
                Connect with Us!
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-gray-700"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t border-gray-100 pt-4">
            <div className="flex flex-col space-y-3">
              <a href="#home" className="text-gray-700 hover:text-red-600 transition-colors py-2">Home</a>
              <a href="#about" className="text-gray-700 hover:text-red-600 transition-colors py-2">About</a>
              <a href="#services" className="text-gray-700 hover:text-red-600 transition-colors py-2">Services</a>
              <a href="#gallery" className="text-gray-700 hover:text-red-600 transition-colors py-2">Gallery</a>
              <a href="#album" className="text-gray-700 hover:text-red-600 transition-colors py-2">Album</a>
              <a href="#books" className="text-gray-700 hover:text-red-600 transition-colors py-2">Nadja Scott the Author</a>
              <a href="#/assessment" onClick={handleJoinClick} className="text-red-600 font-bold hover:text-red-700 transition-colors py-2">Join the Choir</a>
              <a href="#bus-of-blessings" className="text-gray-700 hover:text-red-600 transition-colors py-2">Donate</a>
              <a 
                href="https://docs.google.com/forms/d/12hphFMKBt-Zd44mV26mRSBOZkxx0veNAx_E3yN2YRw8/viewform"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-red-600 transition-colors py-2"
              >
                Contact
              </a>
              <a href="#/admin" className="text-gray-700 hover:text-red-600 transition-colors py-2">Admin</a>
              <a 
                href="https://docs.google.com/forms/d/12hphFMKBt-Zd44mV26mRSBOZkxx0veNAx_E3yN2YRw8/viewform"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-full mt-4">
                  Connect with Us!
                </Button>
              </a>
            </div>
          </nav>
        )}
      </div>

      {/* Assessment Warning Modal */}
      {showAssessmentWarning && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm">
          <div className="bg-gradient-to-br from-yellow-400 via-orange-500 to-red-600 p-1 rounded-2xl shadow-2xl max-w-lg mx-4">
            <div className="bg-white rounded-xl p-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Music className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  📍 DMV/Maryland Chapter Only! 📍
                </h3>
                <div className="bg-yellow-50 border-2 border-yellow-400 rounded-lg p-4 mb-4">
                  <p className="text-lg font-semibold text-gray-800 mb-2">
                    You are about to complete the
                  </p>
                  <p className="text-xl font-bold text-red-600 mb-2">
                    DA Membership Application
                  </p>
                  <p className="text-gray-700">
                    This application is for the <strong>DMV/Maryland Chapter</strong> and will take approximately <strong>10-15 minutes</strong> to complete.
                  </p>
                </div>
                <div className="bg-blue-50 border-l-4 border-blue-500 p-3 mb-6 text-left">
                  <p className="text-sm text-gray-700">
                    ✓ Please ensure you have time to complete the entire application<br/>
                    ✓ Answer all questions honestly and thoughtfully<br/>
                    ✓ This is specifically for the DMV/Maryland chapter members
                  </p>
                </div>
                <div className="flex gap-3">
                  <button
                    onClick={() => setShowAssessmentWarning(false)}
                    className="flex-1 px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold rounded-lg transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={proceedToAssessment}
                    className="flex-1 px-6 py-3 bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white font-bold rounded-lg transition-all transform hover:scale-105 shadow-lg"
                  >
                    I'm Ready! →
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};